import classNames from 'classnames'

import { ICON_COLOR, ICON_HEIGHT_24 } from '../../Icon.constants'
import { IconNG } from '../../IconNG'

import * as styles from './IconSpinner.module.css'

import SpinnerIcon from '../../../../icons/spinner/spinner.svg'

function IconSpinner({
  Icon = SpinnerIcon,
  color = ICON_COLOR.TextDisabledColor,
  iconProps,
  size = ICON_HEIGHT_24,
  ...restProps
}) {
  return (
    <IconNG
      {...restProps}
      Icon={Icon}
      color={color}
      iconProps={{
        ...iconProps,
        className: classNames(iconProps?.className, styles.iconSpinner),
      }}
      size={size}
    />
  )
}

export default IconSpinner
